module.exports = __webpack_public_path__ + "static/media/school_detail_banner_top.defffb80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/school_detail_banner_top.png
// module id = 914
// module chunks = 0